var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, observable, makeObservable } from "mobx";
export var DrawerLevel;
(function (DrawerLevel) {
    DrawerLevel["FIRST"] = "first";
    DrawerLevel["SECOND"] = "second";
    DrawerLevel["THIRD"] = "third";
})(DrawerLevel || (DrawerLevel = {}));
export var ManagerFeature;
(function (ManagerFeature) {
    ManagerFeature["AGENTS"] = "agents";
    ManagerFeature["DEPARTMENTS"] = "departments";
    ManagerFeature["LABELS"] = "labels";
    ManagerFeature["CHANNELS"] = "channels";
    ManagerFeature["API_TOKENS"] = "apiTokens";
    ManagerFeature["OAUTH"] = "oauth";
})(ManagerFeature || (ManagerFeature = {}));
export var ManagerOperation;
(function (ManagerOperation) {
    ManagerOperation["VIEW"] = "view";
    ManagerOperation["CREATE"] = "create";
    ManagerOperation["EDIT"] = "edit";
    ManagerOperation["DELETE"] = "delete";
})(ManagerOperation || (ManagerOperation = {}));
class UIStore {
    constructor(rootStore) {
        Object.defineProperty(this, "rootStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "managersDrawer", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {
                openDrawers: new Set(),
                secondLevelState: null,
                thirdLevelState: null,
            }
        });
        Object.defineProperty(this, "openSecondLevelManager", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (feature) => {
                this.managersDrawer.secondLevelState = { feature };
                this.managersDrawer.openDrawers.add(DrawerLevel.SECOND);
            }
        });
        Object.defineProperty(this, "openThirdLevelManager", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (id, operation = ManagerOperation.EDIT) => {
                this.managersDrawer.thirdLevelState = { id, operation };
                this.managersDrawer.openDrawers.add(DrawerLevel.THIRD);
            }
        });
        Object.defineProperty(this, "closeManagerDrawer", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (level) => {
                this.managersDrawer.openDrawers.delete(level);
                // Close all deeper levels and clear their state when closing a level
                if (level === DrawerLevel.FIRST) {
                    this.managersDrawer.openDrawers.delete(DrawerLevel.SECOND);
                    this.managersDrawer.openDrawers.delete(DrawerLevel.THIRD);
                    this.managersDrawer.secondLevelState = null;
                    this.managersDrawer.thirdLevelState = null;
                }
                else if (level === DrawerLevel.SECOND) {
                    this.managersDrawer.openDrawers.delete(DrawerLevel.THIRD);
                    this.managersDrawer.secondLevelState = null;
                    this.managersDrawer.thirdLevelState = null;
                }
                else if (level === DrawerLevel.THIRD) {
                    this.managersDrawer.thirdLevelState = null;
                }
            }
        });
        Object.defineProperty(this, "toggleManagerDrawer", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (level) => {
                if (this.isManagerDrawerOpen(level)) {
                    this.closeManagerDrawer(level);
                }
                else {
                    this.managersDrawer.openDrawers.add(level);
                }
            }
        });
        Object.defineProperty(this, "isManagerDrawerOpen", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (level) => {
                return this.managersDrawer.openDrawers.has(level);
            }
        });
        Object.defineProperty(this, "getManagerFeature", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                var _a, _b;
                return (_b = (_a = this.managersDrawer.secondLevelState) === null || _a === void 0 ? void 0 : _a.feature) !== null && _b !== void 0 ? _b : null;
            }
        });
        Object.defineProperty(this, "getManagerItemId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                var _a, _b;
                return (_b = (_a = this.managersDrawer.thirdLevelState) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : null;
            }
        });
        Object.defineProperty(this, "getManagerOperation", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                var _a, _b;
                return (_b = (_a = this.managersDrawer.thirdLevelState) === null || _a === void 0 ? void 0 : _a.operation) !== null && _b !== void 0 ? _b : null;
            }
        });
        Object.defineProperty(this, "closeAllManagerDrawers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.managersDrawer.openDrawers.clear();
                this.managersDrawer.secondLevelState = null;
                this.managersDrawer.thirdLevelState = null;
            }
        });
        makeObservable(this);
        this.rootStore = rootStore;
    }
}
__decorate([
    observable
], UIStore.prototype, "managersDrawer", void 0);
__decorate([
    action
], UIStore.prototype, "openSecondLevelManager", void 0);
__decorate([
    action
], UIStore.prototype, "openThirdLevelManager", void 0);
__decorate([
    action
], UIStore.prototype, "closeManagerDrawer", void 0);
__decorate([
    action
], UIStore.prototype, "toggleManagerDrawer", void 0);
__decorate([
    action
], UIStore.prototype, "closeAllManagerDrawers", void 0);
export default UIStore;
